module.exports = __webpack_public_path__ + "img/alimentacion.e29f5507.png";